export const UsersPage = () => {
  return (
    <>
      <div>This is users</div>
    </>
  );
};
